(function () {
  'use strict';

  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(
      container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!focusable.length) { e.preventDefault(); return; }
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  var ROOM_ORDER = [
    'Product details',
    'Kitchen',
    'living room',
    'Bathroom',
    'Bedroom',
    'Shower',
    'Pool',
    'entryway',
    'Dining',
    'Fireplace',
    'Exterior',
    'Laundry',
    'Office',
    'Mudroom',
    'Hallway',
    'Stairs',
    'Stair risers',
    'Balcony',
    'Gym',
    'Commercial'
  ];

  // Lowercase lookup set for O(1) matching
  var ROOM_SET = ROOM_ORDER.reduce(function (acc, r) {
    acc[r.toLowerCase()] = r;
    return acc;
  }, {});

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  /**
   * @param {Array} hotspots - from ppt-data media.hotspots
   * @returns {string} HTML for overlay (empty string if none)
   */
  /**
   * Build "$108.15 / Box of 50" from variant price + title (e.g. "106 Ivory Beige / Box of 50").
   */
  function formatHotspotPriceLine(variant) {
    var price = (variant && variant.price) || '';
    var title = (variant && variant.title) || '';
    var boxMatch = title.match(/Box\s+of\s+\d+/i);
    if (price && boxMatch) return price + ' / ' + boxMatch[0];
    return price;
  }

  function renderHotspotsHtml(hotspots) {
    if (!hotspots || !hotspots.length) return '';
    var markers = hotspots.map(function (hs) {
      var v = hs.variant || {};
      var aria = hs.label || v.product_title || 'View product';
      var x = Number(hs.x);
      var y = Number(hs.y);
      if (isNaN(x)) x = 50;
      if (isNaN(y)) y = 50;
      var priceLine = formatHotspotPriceLine(v);
      return [
        '<button type="button" class="ppt-hotspot" data-ppt-hotspot="' + escapeAttr(hs.id) + '"',
        ' style="left:' + x + '%;top:' + y + '%;"',
        ' aria-label="' + escapeAttr(aria) + '"',
        ' aria-expanded="false">',
        '<span class="ppt-hotspot__dot" aria-hidden="true"></span>',
        '</button>',
        '<div class="ppt-hotspot-card" data-ppt-hotspot-card="' + escapeAttr(hs.id) + '" hidden>',
          '<a class="ppt-hotspot-card__link" href="' + escapeAttr(v.url || '#') + '">',
            v.image
              ? '<img class="ppt-hotspot-card__img" src="' + escapeAttr(v.image) + '" alt="" width="72" height="72" loading="lazy">'
              : '',
            '<span class="ppt-hotspot-card__body">',
              '<span class="ppt-hotspot-card__title">' + escapeHtml(v.product_title || '') + '</span>',
              priceLine
                ? '<span class="ppt-hotspot-card__price">' + escapeHtml(priceLine) + '</span>'
                : '',
              '<span class="ppt-hotspot-card__cta">View product</span>',
            '</span>',
          '</a>',
        '</div>'
      ].join('');
    }).join('');
    return '<div class="ppt-hotspots" data-ppt-hotspots>' + markers + '</div>';
  }

  window.PdpPhotoTour = window.PdpPhotoTour || {};
  window.PdpPhotoTour._renderHotspotsHtml = renderHotspotsHtml;
  window.PdpPhotoTour._escapeHtml = escapeHtml;

  /**
   * Parse a Shopify media alt into { room, label, variantTokens }.
   * Formats:
   *   "Room - description#Token1_Token2"
   *   "Room#Token1_Token2"   (room alone before #)
   * Fallback room: 'Product details'
   */
  function parseAlt(alt) {
    var raw = alt || '';
    var hashIdx = raw.indexOf('#');
    var variantTokens = [];
    var label = raw;

    if (hashIdx !== -1) {
      variantTokens = raw.slice(hashIdx + 1).split('_').map(function (t) {
        return t.trim().toLowerCase();
      }).filter(Boolean);
      label = raw.slice(0, hashIdx);
    }

    var trimmed = label.trim();
    var dashIdx = trimmed.indexOf(' - ');
    var roomRaw = dashIdx !== -1 ? trimmed.slice(0, dashIdx).trim() : trimmed;
    var room = ROOM_SET[roomRaw.toLowerCase()] || 'Product details';

    return { room: room, label: trimmed, variantTokens: variantTokens };
  }

  /**
   * Given the full media array and the current variant's option handles,
   * return only the media that should appear in the tour.
   *
   * A media item is visible if:
   *   - its alt has no '#' (shared), OR
   *   - its dataMediaType is blank (product uses no # alts at all), OR
   *   - its dataMediaType intersects selectedVariantOptions
   *
   * 3D models are excluded; images + hosted/external video are included.
   */
  function filterMedia(media, selectedVariantOptions) {
    var hasAnyHash = media.some(function (m) { return m.alt && m.alt.indexOf('#') !== -1; });

    return media.filter(function (m) {
      if (m.type !== 'image' && m.type !== 'video' && m.type !== 'external_video') return false;
      if (!hasAnyHash) return true;
      if (!m.alt || m.alt.indexOf('#') === -1) return true; // shared
      // Has # — check dataMediaType against selected options
      if (!m.dataMediaType) return false;
      var mediaTypes = m.dataMediaType.split('_').filter(Boolean);
      return mediaTypes.every(function (t) {
        return selectedVariantOptions.indexOf(t) !== -1;
      });
    });
  }

  function isVideoMedia(item) {
    return item && (item.type === 'video' || item.type === 'external_video');
  }

  function playIconHtml() {
    return '<span class="ppt-section__play" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14" fill="currentColor" width="14" height="18">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z"/>' +
      '</svg>' +
    '</span>';
  }

  /**
   * Group filtered media into ordered sections.
   * Returns array of { room: String, images: [mediaItem] }
   */
  function buildSections(visibleMedia) {
    var map = {};
    visibleMedia.forEach(function (m) {
      var parsed = parseAlt(m.alt);
      m._room = parsed.room;
      m._label = parsed.label;
      if (!map[parsed.room]) map[parsed.room] = [];
      map[parsed.room].push(m);
    });

    return ROOM_ORDER
      .filter(function (r) { return map[r] && map[r].length > 0; })
      .map(function (r) { return { room: r, images: map[r] }; });
  }

  // Expose for Task 4 init
  window.PdpPhotoTour = window.PdpPhotoTour || {};
  window.PdpPhotoTour._parseAlt = parseAlt;
  window.PdpPhotoTour._filterMedia = filterMedia;
  window.PdpPhotoTour._buildSections = buildSections;
  window.PdpPhotoTour.instances = window.PdpPhotoTour.instances || {};

  window.PdpPhotoTour.init = function (config) {
    // Guard against double-init
    if (window.PdpPhotoTour.instances[config.sectionId]) return;

    var sectionId = config.sectionId;
    var media = config.media;
    var openOnClick = config.openOnClick;
    var selectedOptions = (config.selectedVariantOptions || []).map(function (o) { return o.toLowerCase(); });

    var instance = {
      sectionId: sectionId,
      openOnClick: openOnClick,
      allMedia: media,
      selectedOptions: selectedOptions,
      sections: [],
      flatList: [],
      tourEl: null,
      _focusOrigin: null,

      _reducedMotion: function () {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      },

      build: function () {
        var filtered = window.PdpPhotoTour._filterMedia(this.allMedia, this.selectedOptions);
        this.sections = window.PdpPhotoTour._buildSections(filtered);
        this.flatList = filtered;
        var self = this;
        this.flatList = [];
        this.sections.forEach(function (sec) { self.flatList = self.flatList.concat(sec.images); });
      },

      render: function () {
        var self = this;
        var tourId = 'ppt-tour-' + sectionId;
        var existing = document.getElementById(tourId);
        if (existing) {
          if (existing._keyHandler) document.removeEventListener('keydown', existing._keyHandler);
          if (this._scrollObs) { this._scrollObs.disconnect(); this._scrollObs = null; }
          existing.remove();
        }

        var tour = document.createElement('div');
        tour.id = tourId;
        tour.className = 'ppt-tour';
        tour.setAttribute('role', 'dialog');
        tour.setAttribute('aria-modal', 'true');
        tour.setAttribute('aria-labelledby', 'ppt-title-' + sectionId);

        var showNav = this.sections.length > 1;

        tour.innerHTML = [
          '<div class="ppt-tour__header">',
            '<button class="ppt-tour__close" type="button" aria-label="Close photo tour" data-ppt-close>',
              '<span class="ppt-tour__close-icon" aria-hidden="true">&#x2715;</span>',
              '<span class="ppt-tour__title" id="ppt-title-' + sectionId + '">Photo tour</span>',
            '</button>',
          '</div>',
          showNav ? '<nav class="ppt-tour__nav" aria-label="Jump to room">' +
            this.sections.map(function (sec) {
              var thumb = sec.images[0];
              return '<button class="ppt-tour__nav-item" data-ppt-nav="' + sec.room + '" aria-label="Scroll to ' + sec.room + '">' +
                '<img class="ppt-tour__nav-thumb" src="' + (thumb.srcThumb || thumb.src) + '" srcset="' + (thumb.srcThumb || thumb.src) + ' 144w, ' + (thumb.srcThumbMd || thumb.src) + ' 200w, ' + (thumb.srcThumbLg || thumb.src) + ' 240w" sizes="(min-width: 1200px) 120px, (min-width: 768px) 100px, 72px" width="72" height="72" alt="">' +
                '<span class="ppt-tour__nav-label">' + sec.room + '</span>' +
              '</button>';
            }).join('') +
          '</nav>' : '',
          '<div class="ppt-sections">',
            this.sections.map(function (sec, secIdx) {
              var isFirstSection = secIdx === 0;
              return '<section class="ppt-section" data-ppt-section-name="' + sec.room + '">' +
                '<div class="ppt-section__title-wrap"><h3 class="ppt-section__title">' + sec.room + '</h3></div>' +
                '<div class="ppt-section__grid">' +
                  sec.images.map(function (img, imgIdx) {
                    var flatIdx = self.flatList.indexOf(img);
                    var eager = isFirstSection && imgIdx < 2;
                    var srcSm = img.srcSm || img.src;
                    var srcMd = img.srcMd || img.src;
                    var hotspotsHtml = isVideoMedia(img) ? '' : renderHotspotsHtml(img.hotspots);
                    var cellClass = hotspotsHtml ? ' ppt-section__cell--has-hotspots' : '';
                    if (isVideoMedia(img)) cellClass += ' ppt-section__cell--video';
                    var ariaLabel = isVideoMedia(img)
                      ? ('Play video' + (img._label || img.alt ? ': ' + (img._label || img.alt) : ''))
                      : ('View ' + (img._label || img.alt || sec.room) + ' fullscreen');
                    return '<div class="ppt-section__cell' + cellClass + '">' +
                      '<button class="ppt-section__img-btn" type="button" data-ppt-open-lb="' + flatIdx + '" aria-label="' + escapeAttr(ariaLabel) + '">' +
                        '<img class="ppt-section__img" src="' + img.src + '" srcset="' + srcSm + ' 450w, ' + img.src + ' 800w, ' + srcMd + ' 1100w" sizes="(min-width: 900px) 480px, (min-width: 640px) 50vw, 100vw" alt="' + escapeAttr(img._label || '') + '"' + (eager ? '' : ' loading="lazy"') + '>' +
                        (isVideoMedia(img) ? playIconHtml() : '') +
                      '</button>' +
                      hotspotsHtml +
                    '</div>';
                  }).join('') +
                '</div>' +
              '</section>';
            }).join('') +
          '</div>'
        ].join('');

        document.body.appendChild(tour);
        this.tourEl = tour;
        this._bindTourEvents();
      },

      _bindTourEvents: function () {
        var self = this;
        var tour = this.tourEl;

        tour.querySelector('[data-ppt-close]').addEventListener('click', function () {
          self.closeTour();
        });

        tour._keyHandler = function (e) {
          if (e.key === 'Escape') {
            if (self.lbEl && self.lbEl.classList.contains('ppt-lb--open')) return;
            if (self.tourEl && self.tourEl.querySelector('[data-ppt-hotspot-card]:not([hidden])')) {
              self.closeAllHotspotCards();
              e.preventDefault();
              return;
            }
            self.closeTour();
            return;
          }
          if (self.lbEl && self.lbEl.classList.contains('ppt-lb--open')) return;
          trapFocus(tour, e);
        };
        document.addEventListener('keydown', tour._keyHandler);

        tour.querySelectorAll('[data-ppt-nav]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var room = btn.getAttribute('data-ppt-nav');
            var target = tour.querySelector('[data-ppt-section-name="' + room + '"]');
            if (!target) return;
            target.scrollIntoView({ behavior: self._reducedMotion() ? 'instant' : 'smooth' });
          });
        });

        tour.querySelectorAll('[data-ppt-open-lb]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            if (e.target.closest('[data-ppt-hotspot], [data-ppt-hotspot-card]')) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            self.closeAllHotspotCards();
            var idx = parseInt(btn.getAttribute('data-ppt-open-lb'), 10);
            self.openLightbox(idx);
          });
        });

        var hoverCapable = window.matchMedia('(hover: hover)').matches;

        tour.querySelectorAll('[data-ppt-hotspot]').forEach(function (marker) {
          marker.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var id = marker.getAttribute('data-ppt-hotspot');
            var expanded = marker.getAttribute('aria-expanded') === 'true';
            if (expanded) {
              self.closeAllHotspotCards();
            } else {
              self.openHotspotCard(id);
            }
          });

          marker.addEventListener('focus', function () {
            self.openHotspotCard(marker.getAttribute('data-ppt-hotspot'));
          });

          if (hoverCapable) {
            var hotspotId = marker.getAttribute('data-ppt-hotspot');
            var pairedCard = tour.querySelector('[data-ppt-hotspot-card="' + hotspotId + '"]');
            var HOVER_CLOSE_MS = 180;

            function cancelHotspotClose() {
              clearTimeout(self._hotspotCloseTimer);
              self._hotspotCloseTimer = null;
            }

            function scheduleHotspotClose() {
              cancelHotspotClose();
              self._hotspotCloseTimer = setTimeout(function () {
                self._hotspotCloseTimer = null;
                self.closeAllHotspotCards();
              }, HOVER_CLOSE_MS);
            }

            marker.addEventListener('mouseenter', function () {
              cancelHotspotClose();
              self.openHotspotCard(hotspotId);
            });

            marker.addEventListener('mouseleave', function (e) {
              var related = e.relatedTarget;
              if (related && pairedCard && pairedCard.contains(related)) return;
              scheduleHotspotClose();
            });

            if (pairedCard) {
              pairedCard.addEventListener('mouseenter', cancelHotspotClose);
              pairedCard.addEventListener('mouseleave', function (e) {
                var related = e.relatedTarget;
                if (related && (related === marker || marker.contains(related))) return;
                scheduleHotspotClose();
              });
            }
          }
        });

        tour.addEventListener('click', function (e) {
          if (e.target.closest('[data-ppt-hotspot], [data-ppt-hotspot-card]')) return;
          if (tour.querySelector('[data-ppt-hotspot-card]:not([hidden])')) {
            self.closeAllHotspotCards();
          }
        });

        this._setupScrollSpy();
      },

      _setupScrollSpy: function () {
        var self = this;
        var sections = this.tourEl.querySelectorAll('[data-ppt-section-name]');
        if (!sections.length) return;

        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var room = entry.target.getAttribute('data-ppt-section-name');
            self.tourEl.querySelectorAll('[data-ppt-nav]').forEach(function (btn) {
              btn.classList.toggle('ppt-tour__nav-item--active', btn.getAttribute('data-ppt-nav') === room);
            });
          });
        }, { root: null, rootMargin: '-10% 0px -80% 0px', threshold: 0 });

        sections.forEach(function (sec) { obs.observe(sec); });
        this._scrollObs = obs;
      },

      _buildLightbox: function () {
        var lbId = 'ppt-lb-' + this.sectionId;
        var existing = document.getElementById(lbId);
        if (existing) {
          if (!existing.querySelector('.ppt-lb__media-wrap')) {
            existing.remove();
          } else {
            this.lbEl = existing;
            return existing;
          }
        }

        var lb = document.createElement('div');
        lb.id = lbId;
        lb.className = 'ppt-lb';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.setAttribute('aria-label', 'Photo fullscreen view');
        lb.innerHTML =
          '<button class="ppt-lb__close" aria-label="Close fullscreen view">&#x2715;</button>' +
          '<button class="ppt-lb__prev" aria-label="Previous photo">&#8249;</button>' +
          '<div class="ppt-lb__media-wrap"></div>' +
          '<button class="ppt-lb__next" aria-label="Next photo">&#8250;</button>' +
          '<div class="ppt-lb__caption"></div>';

        document.body.appendChild(lb);

        var self = this;

        lb.querySelector('.ppt-lb__close').addEventListener('click', function () { self.closeLightbox(); });
        lb.querySelector('.ppt-lb__prev').addEventListener('click', function () { self._lbStep(-1); });
        lb.querySelector('.ppt-lb__next').addEventListener('click', function () { self._lbStep(1); });

        lb._keyHandler = function (e) {
          if (e.key === 'Escape') { self.closeLightbox(); return; }
          if (e.key === 'ArrowLeft') { self._lbStep(-1); return; }
          if (e.key === 'ArrowRight') { self._lbStep(1); return; }
          trapFocus(lb, e);
        };

        this.lbEl = lb;
        return lb;
      },

      _lbStopMedia: function () {
        if (!this.lbEl) return;
        var wrap = this.lbEl.querySelector('.ppt-lb__media-wrap');
        if (!wrap) return;
        var video = wrap.querySelector('video');
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(function (s) { s.remove(); });
          try { video.load(); } catch (e) {}
        }
        wrap.innerHTML = '';
      },

      _lbStep: function (dir) {
        var next = this._lbIndex + dir;
        if (next < 0 || next >= this.flatList.length) return;
        this._lbShow(next);
      },

      _lbShow: function (idx) {
        this._lbIndex = idx;
        var item = this.flatList[idx];
        var lb = this.lbEl;
        this._lbStopMedia();
        var wrap = lb.querySelector('.ppt-lb__media-wrap');
        if (!wrap) return;

        if (item.type === 'video') {
          var ratio = Number(item.aspectRatio);
          if (!ratio || ratio <= 0) ratio = 9 / 16;
          var sources = (item.sources || []).map(function (s) {
            return '<source src="' + escapeAttr(s.url) + '"' + (s.mime_type ? ' type="' + escapeAttr(s.mime_type) + '"' : '') + '>';
          }).join('');
          wrap.innerHTML =
            '<div class="ppt-lb__video-wrap" style="aspect-ratio: ' + ratio + '; width: min(720px, 90vw, calc(80vh * ' + ratio + '));">' +
              '<video class="ppt-lb__video" controls playsinline preload="metadata" poster="' + escapeAttr(item.srcLarge || item.src) + '">' +
                sources +
              '</video>' +
            '</div>';
          var videoEl = wrap.querySelector('video');
          if (videoEl) {
            videoEl.play().catch(function () {});
          }
        } else if (item.type === 'external_video' && item.externalId) {
          var src = item.host === 'vimeo'
            ? ('https://player.vimeo.com/video/' + item.externalId + '?autoplay=1&playsinline=1')
            : ('https://www.youtube.com/embed/' + item.externalId + '?autoplay=1&playsinline=1&rel=0');
          wrap.innerHTML =
            '<div class="ppt-lb__iframe-wrap">' +
              '<iframe class="ppt-lb__iframe" src="' + escapeAttr(src) + '" title="' + escapeAttr(item._label || item.alt || 'Video') + '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' +
            '</div>';
        } else {
          wrap.innerHTML =
            '<img class="ppt-lb__img" src="' + escapeAttr(item.srcLarge || item.src) + '" alt="' + escapeAttr(item._label || item.alt || '') + '">';
        }

        lb.querySelector('.ppt-lb__caption').textContent =
          (idx + 1) + ' / ' + this.flatList.length + ' \u00B7 ' + item._room;
        lb.querySelector('.ppt-lb__prev').disabled = idx === 0;
        lb.querySelector('.ppt-lb__next').disabled = idx === this.flatList.length - 1;
      },

      openLightbox: function (idx) {
        this._buildLightbox();
        var lb = this.lbEl;
        this._lbShow(idx);
        lb.classList.add('ppt-lb--open');
        document.removeEventListener('keydown', lb._keyHandler);
        document.addEventListener('keydown', lb._keyHandler);
        lb.querySelector('.ppt-lb__close').focus();
      },

      closeLightbox: function () {
        if (!this.lbEl) return;
        this._lbStopMedia();
        this.lbEl.classList.remove('ppt-lb--open');
        document.removeEventListener('keydown', this.lbEl._keyHandler);
        // Return focus to the image button inside the tour
        if (this.tourEl) {
          var btn = this.tourEl.querySelector('[data-ppt-open-lb="' + this._lbIndex + '"]');
          if (btn) btn.focus();
        }
      },

      openTour: function (mediaId) {
        this.build();
        this.render();
        var tour = this.tourEl;
        tour.classList.add('ppt-tour--open');
        document.body.style.overflow = 'hidden';

        var firstFocusable = tour.querySelector('button');
        if (firstFocusable) firstFocusable.focus();

        if (mediaId) {
          var idx = this.flatList.findIndex(function (m) { return String(m.id) === String(mediaId); });
          if (idx > -1) {
            var room = this.flatList[idx]._room;
            var sec = tour.querySelector('[data-ppt-section-name="' + room + '"]');
            if (sec) {
              setTimeout(function () {
                sec.scrollIntoView({ behavior: 'instant' });
              }, 50);
            }
          }
        }
      },

      closeAllHotspotCards: function () {
        if (!this.tourEl) return;
        clearTimeout(this._hotspotCloseTimer);
        this._hotspotCloseTimer = null;
        this.tourEl.querySelectorAll('[data-ppt-hotspot-card]').forEach(function (card) {
          card.hidden = true;
        });
        this.tourEl.querySelectorAll('[data-ppt-hotspot]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
          btn.classList.remove('is-active');
        });
      },

      openHotspotCard: function (hotspotId) {
        if (!this.tourEl) return;
        clearTimeout(this._hotspotCloseTimer);
        this._hotspotCloseTimer = null;
        this.closeAllHotspotCards();
        var btn = this.tourEl.querySelector('[data-ppt-hotspot="' + hotspotId + '"]');
        var card = this.tourEl.querySelector('[data-ppt-hotspot-card="' + hotspotId + '"]');
        if (!btn || !card) return;
        card.style.left = btn.style.left || '50%';
        card.style.top = btn.style.top || '50%';
        card.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('is-active');
      },

      closeTour: function () {
        if (!this.tourEl) return;
        this.closeAllHotspotCards();
        this.tourEl.classList.remove('ppt-tour--open');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.tourEl._keyHandler);
        if (this._scrollObs) { this._scrollObs.disconnect(); this._scrollObs = null; }
        if (this._focusOrigin) { this._focusOrigin.focus(); this._focusOrigin = null; }
      }
    };

    window.PdpPhotoTour.instances[sectionId] = instance;

    var trigger = document.querySelector('[data-ppt-section="' + sectionId + '"].ppt-trigger');
    if (trigger) {
      trigger.addEventListener('click', function () {
        instance._focusOrigin = trigger;
        instance.openTour();
      });
    }

    function syncTriggerForVariantVideo() {
      if (!trigger) return;
      var filtered = filterMedia(instance.allMedia, instance.selectedOptions);
      var hasVideo = filtered.some(isVideoMedia);
      trigger.classList.toggle('ppt-trigger--no-video', !hasVideo);
    }
    syncTriggerForVariantVideo();

    // Click-to-tour on desktop stacked images only (md+).
    // Mobile: free swipe; tour opens via Show all photos only.
    if (openOnClick) {
      var mediaContainer = document.querySelector('.x-product-' + sectionId + ' .product-media-container');
      if (mediaContainer) {
        var desktopClickMq = window.matchMedia('(min-width: 768px)');
        mediaContainer.addEventListener('click', function (e) {
          if (!desktopClickMq.matches) return;

          // prevent zoom and other click handlers
          var mediaItem = e.target.closest('.product-media-item, .x-thumbnail, .media-thumbnail, .splide__slide[data-media-id]');
          if (!mediaItem) return;
          if (e.target.closest('.ppt-trigger')) return;
          if (e.target.closest('.splide__arrow, .splide__arrows')) return;
          if (e.target.closest('[data-media-id^="zoom-"]') || e.target.closest('model-viewer') || e.target.closest('video')) return;
          // Let video play UI handle clicks (poster / play button); tour is images-only
          if (e.target.closest('.product-media--video, .external-video, .button-play')) return;

          var rawMediaId = mediaItem.getAttribute('data-media-id') || '';
          var mediaId = rawMediaId.replace(sectionId + '-', '');
          if (!mediaId || mediaId === rawMediaId) return;

          // Skip non-image media (video/model not in tour payload)
          var isTourMedia = media.some(function (m) { return String(m.id) === String(mediaId); });
          if (!isTourMedia) return;

          e.preventDefault();
          e.stopImmediatePropagation();

          instance._focusOrigin = mediaItem;
          instance.openTour(mediaId);
        }, true);
      }
    }

    function normalizeVariantOptions(input) {
      if (!Array.isArray(input)) return [];
      return input.map(function (o) { return String(o).toLowerCase(); }).filter(Boolean);
    }

    function rehydrateOpenTour() {
      if (!instance.tourEl || !instance.tourEl.classList.contains('ppt-tour--open')) return;

      var prevRoom = null;
      var activeNav = instance.tourEl.querySelector('.ppt-tour__nav-item--active');
      if (activeNav) prevRoom = activeNav.getAttribute('data-ppt-nav');

      if (instance.lbEl && instance.lbEl.classList.contains('ppt-lb--open')) {
        instance.closeLightbox();
      }

      instance.build();
      instance.render();
      instance.tourEl.classList.add('ppt-tour--open');
      document.body.style.overflow = 'hidden';

      if (prevRoom) {
        var targetSec = instance.tourEl.querySelector('[data-ppt-section-name="' + prevRoom + '"]');
        if (targetSec) {
          setTimeout(function () { targetSec.scrollIntoView({ behavior: 'instant' }); }, 50);
        }
      }
    }

    // Variant change reactivity
    document.addEventListener('eurus:variant-change', function (e) {
      if (!e.detail || e.detail.sectionId !== sectionId) return;
      var newOptions = e.detail.variantOptionHandles || e.detail.optionValues || e.detail.variantOptions || e.detail.options || [];
      instance.selectedOptions = normalizeVariantOptions(newOptions);
      syncTriggerForVariantVideo();
      rehydrateOpenTour();
    });

    // Theme variant event fallback (dispatched by variant-select/theme-editor)
    document.addEventListener('eurus:product-page-variant-select:updated:' + sectionId, function (e) {
      if (!e.detail) return;
      // Derive handleized option handles from [data-option-name] fieldsets in the product section
      var sectionEl = document.querySelector('.x-product-' + sectionId);
      var newOptions = [];
      if (sectionEl) {
        sectionEl.querySelectorAll('[data-option-name]').forEach(function (fieldset) {
          var optName = fieldset.dataset.optionName; // already handleized by Liquid | handle filter
          var optVal = '';
          // Button/swatch picker
          var checkedInput = fieldset.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
          if (checkedInput) {
            optVal = checkedInput.value.toLowerCase().replace(/[\s\/\\,\.]+/g, '-');
          } else {
            // Select / dropdown picker
            var selectEl = fieldset.querySelector('select');
            if (selectEl) {
              optVal = selectEl.value.toLowerCase().replace(/[\s\/\\,\.]+/g, '-');
            }
          }
          if (optName && optVal) {
            newOptions.push(optName + '-' + optVal);
          }
        });
      }
      // Fallback: use display values if DOM query found nothing
      if (!newOptions.length && e.detail && e.detail.options) {
        newOptions = e.detail.options.map(function (v) { return String(v).toLowerCase().replace(/[\s\/\\,\.]+/g, '-'); });
      }
      instance.selectedOptions = newOptions;
      syncTriggerForVariantVideo();
      rehydrateOpenTour();
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="ppt-data-"]').forEach(function (el) {
      try {
        var config = JSON.parse(el.textContent);
        if (window.PdpPhotoTour && window.PdpPhotoTour.init) {
          window.PdpPhotoTour.init(config);
        }
      } catch (e) {
        console.warn('[PdpPhotoTour] Failed to parse config', e);
      }
    });
  });
})();
